import { createContext, useContext } from 'react';

const ScrollContext = createContext(null);

export const ScrollProvider = ScrollContext.Provider;
export const useScrollContainer = () => useContext(ScrollContext);
